import MuiContainer from '@material-ui/core/Container';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme: { font } }) => font.mainFont()};
  background: linear-gradient(90deg, #2153fd 0%, #04bbff 100%);
  color: ${({ theme: { color } }) => color.white_500};
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 21px;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
  text-align: center;
  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('sm')} {
      display: block;
    }
  `}
`;

export const Img = styled.img`
  margin-bottom: 50px;
  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('sm')} {
      margin: 50px auto;
    }
  `}
`;

export const Header = styled.header`
  border-bottom: 1px solid ${({ theme: { color } }) => color.white_700};
  width: 100%;
  padding: 12px 0px;
  text-align: center;
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 32px;
  line-height: 42px;
  margin-top: 0;

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('xs')} {
      font-size: 24px;
    }
  `}
`;

export const Description = styled.p`
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  margin-block-start: 0px;
`;

export const Container = styled(MuiContainer)`
  && {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
  }
`;

export const Supporter = styled.a`
  color: #fbc02d;
  font-weight: bold;
  padding: 0 8px;
  text-decoration: none;
`;
export const FeedbackLink = styled.span`
  cursor: pointer;
`;
